export default __webpack_public_path__ + "static/thermic-lance-e84e6436336d3e3470c525d657fc5a37.png";